import { render, staticRenderFns } from "./MyStudy.vue?vue&type=template&id=a549a0ca&scoped=true"
import script from "./MyStudy.vue?vue&type=script&lang=js"
export * from "./MyStudy.vue?vue&type=script&lang=js"
import style0 from "./MyStudy.vue?vue&type=style&index=0&id=a549a0ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a549a0ca",
  null
  
)

export default component.exports